module.exports = __webpack_public_path__ + "assets/img/aa4b-mk.svg";